import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../../context/userAuth.context";
import Swal from "sweetalert2";

export const TemplateItem = (props) => {
  const { authenticationData, Access, getLink } = useContext(AuthContext);

  const popfunction = (e) => {
    if (Access == "FE" && props.isPremium) {
      Swal.fire({
        title: "Upgrade Required",
        html: `You have not purchased this upgrade yet. Please <a href=${getLink()} target='_blank'>upgrade</a> to unlock all features.`,
        icon: "info",
        cancelButtonColor: "#d33",
        backdrop: null,
      });
    } else {
      e.preventDefault();
      props.showpop(true);
      props.start(props.ProjectData);
    }
  };
  const [testWidth, settestWidth] = useState("");
  const [testHeight, settestHeight] = useState("");
  const [testRatio, settestRatio] = useState("");
  const [testPadding, settestPadding] = useState("");
  useEffect(() => {
    if (props.imgSrc != null && props.imgSrc != "") {
      //let x = getMeta(authenticationData.ApiBaseURL + "/" +  props.imgSrc)
      var w = props.ProjectData.canvasSize.split(":")[0];
      var h = props.ProjectData.canvasSize.split(":")[1];
      let ratio = w / h;
      let padding = (h / w) * 100 + "%";
      settestRatio(ratio);
      settestPadding(padding);
    }
  }, []);

  const [hoverItem, sethoverItem] = useState();
  return (
    <>
      <a
        onClick={(e) => popfunction(e)}
        onMouseOver={() => {
          sethoverItem(true);
        }}
        onMouseLeave={() => {
          sethoverItem(false);
        }}
        class="captionWrapper___15cOi item___3380i bottomIndentSmall___3TgBx"
        style={{ width: 184 * testRatio, flexGrow: testRatio * 10 }}
        href="#"
      >
        <div
          class={
            hoverItem
              ? "cardCust preview___2p4uz imgWrapper___1dRUW imgWrapper___20yEp translateItem"
              : "cardCust preview___2p4uz imgWrapper___1dRUW imgWrapper___20yEp"
          }
          style={{ paddingBottom: testPadding, position: "relative" }}
        >
          {Access == "FE" && props.isPremium ? (
            <img
              className="premiumIcon"
              style={{
                top: "7px",
                right: "7px",
                width: "32px",
              }}
              src="../AppIcons/IconsAll/PremiumIcon.svg"
              alt=""
            />
          ) : null}

          <img
            alt=""
            loading="lazy"
            src={
              props.imgSrc != null && props.imgSrc != ""
                ? authenticationData.ApiBaseURL + "/" + props.imgSrc
                : authenticationData.ApiBaseURL +
                  "/" +
                  "images/DefaultProject.png"
            }
            class="itemImg___1GRZk templatesSearchResults"
          />
        </div>
        <div class="caption___14hDw proxima-semibold___1HNzk proxima-s___29loE">
          <div class="title___3aJ-x"> {props.title}</div>
          <div class="subTitle___2DmoO2">{props.size}</div>
        </div>
      </a>

      {/* <div className="cardCust" style={{ paddingBottom: "" + props.paddingRatio + "%" }}>
        <div className="cardOverlay">
          <span className="material-icons-outlined iconPlayTemplate">play_circle_outline</span>
        </div>
        <div className="contentWrapper">
          <span className="contentInsider">
            <img src={(props.imgSrc != null && props.imgSrc != '') ? authenticationData.ApiBaseURL + "/" +  props.imgSrc : "images/DefaultProject.png"} className="image" alt="" />
          </span>
        </div>
      </div>
      <div className="contentInsider">
        <div className="typography-subheading-s caption___14hDw">
          <div className="title___3aJ-x">{props.title} </div><div>{props.size}</div>
          {/* <div className="subTitle___2DmoO">{props.duration}</div>
        </div>
      </div> */}
    </>
  );
};

export default TemplateItem;
